<template>
  <div id="bg">
    <div id="login_wrap">
      <div id="login">
        <div class="form-box">
          <a-spin tip="Loading..." :spinning="loading">
            <a-form>
              <e-input
                title="用户名"
                :labelCol="6"
                :validate="validateInfos.username"
                v-model:value="modelRef.username"
              />

              <e-input
                title="密码"
                :labelCol="6"
                :validate="validateInfos.password"
                v-model:value="modelRef.password"
                type="password"
              />

              <e-input
                title="确认密码"
                :labelCol="6"
                :validate="validateInfos.password2"
                v-model:value="modelRef.password2"
                type="password"
              />

              <e-input
                title="姓名"
                :labelCol="6"
                :validate="validateInfos.name"
                v-model:value="modelRef.name"
              />

              <e-input
                title="手机号"
                :labelCol="6"
                :validate="validateInfos.mobile"
                v-model:value="modelRef.mobile"
              />

              <e-input
                title="微信名"
                :labelCol="6"
                :validate="validateInfos.wechartName"
                v-model:value="modelRef.wechartName"
              />
              <e-input
                title="微信号"
                :labelCol="6"
                :validate="validateInfos.wechartNum"
                v-model:value="modelRef.wechartNum"
              />
              <e-input
                title="支付宝账号"
                :labelCol="6"
                :validate="validateInfos.aliNum"
                v-model:value="modelRef.aliNum"
              />

              <e-radio
                title="性别"
                :labelCol="6"
                :validate="validateInfos.sex"
                v-model:value="modelRef.sex"
                :options="[
                  {
                    label: '男',
                    value: 1,
                  },
                  {
                    label: '女',
                    value: 2,
                  },
                ]"
              />

              <e-select
                title="写手类型"
                :labelCol="6"
                :validate="validateInfos.roleId"
                v-model:value="modelRef.roleId"
                :options="[
                  { label: '专职写手', value: 4 },
                  { label: '兼职写手', value: 5 },
                ]"
              />

              <a-button block type="primary" class="a-input" @click="onSubmit"
                >注册</a-button
              >
              <div style="text-align: right">
                <router-link class="regist" to="/manage/login"
                  >返回登录</router-link
                >
              </div>
            </a-form>
          </a-spin>
        </div>
      </div>

      <div id="login_img">
        <!-- 图片绘制框 -->
        <span class="circle">
          <span></span>
          <span></span>
        </span>
        <span class="star">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <span class="fly_star">
          <span></span>
          <span></span>
        </span>
        <p id="title">HGWCRM</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import {} from '@ant-design/icons-vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { UserClass } from '@/apis/user'

const useForm = Form.useForm
const api = new UserClass()
export default defineComponent({
  components: {},
  mixins: [form],
  setup () {
    const loading = ref(false)

    const modelRef = reactive({
      username: '',
      password: '',
      password2: '',
      name: '',
      sex: 1,
      mobile: '',
      wechartName: '',
      wechartNum: '',
      aliNum: '',
      roleId: null
    })

    const validatePass = async (rule, value) => {
      if (value === '') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('请确认密码')
      } else {
        if (value !== modelRef.password) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('两次密码不一致')
        }

        return Promise.resolve()
      }
    }

    const validateMobile = async (rule, value) => {
      if (value === '') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('请填写手机号')
      } else {
        if (!/^1[3-9]\d{9}$/.test(value)) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('手机号码格式错误')
        }

        return Promise.resolve()
      }
    }

    const validateWechart = async (rule, value) => {
      if (value === '') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('请填写微信号')
      } else {
        if (!/^[a-zA-Z][a-zA-Z\d_-]{5,19}$/.test(value)) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('微信号格式错误')
        }

        return Promise.resolve()
      }
    }

    const validateUserName = async (rule, value) => {
      if (value === '') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('请填写用户名')
      } else {
        if (!/^[a-zA-Z0-9\d_-][a-zA-Z0-9\d_-]{5,19}$/.test(value)) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('用户名格式错误')
        }

        return Promise.resolve()
      }
    }

    const rulesRef = reactive({
      username: [
        {
          required: true,
          validator: validateUserName
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码'
        }
      ],
      name: [
        {
          required: true,
          message: '请输入姓名'
        }
      ],
      mobile: [
        {
          required: true,
          validator: validateMobile
        }
      ],
      wechartNum: [
        {
          required: true,
          validator: validateWechart
        }
      ],
      password2: [
        {
          required: true,
          validator: validatePass
        }
      ],
      roleId: [
        {
          required: true,
          message: '请选择写手类型'
        }
      ]
    })

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const roles = ref([])

    return {
      roles,
      loading,
      modelRef,
      validateInfos,
      resetFields,
      validate
    }
  },

  mounted () {
    this.$nextTick(() => {
      window.onkeydown = (e) => {
        if (e.keyCode === 13) {
          this.onSubmit()
        }
      }
    })
  },

  unmounted () {
    window.onkeydown = () => true
  },

  methods: {
    onSubmit () {
      this.loading = true
      this.validate()
        .then(() => {
          const data = toRaw(this.modelRef)

          data.username = data.username.trim()
          data.password = data.password.trim()
          data.password2 = data.password2.trim()

          api
            .reg(data)
            .then(() => {
              this.loading = false
              this.$message.success('注册成功，请登录')
              this.$router.push({ name: 'manage-login' })
            })
            .catch((e) => {
              this.loading = false
            })
        })
        .catch(() => {
          this.loading = false
          this.$message.error('请正确输入注册信息')
        })
    }
  }
})
</script>

<style scoped>
#bg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#login_wrap {
  width: 980px;
  height: 660px;
  border-radius: 10px;
  font-family: "neo";
  overflow: hidden;
  box-shadow: 0px 0px 120px rgba(0, 0, 0, 0.25);
}
#login {
  width: 50%;
  height: 100%;
  min-height: 400px;
  background: #fff;
  position: relative;
  float: right;
}
#login #status {
  width: 90px;
  margin: 40px auto;
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  position: relative;
  overflow: hidden;
}
#login #status i {
  font-style: normal;
  position: absolute;
  transition: 0.5s;
}
.form-box {
  padding: 20px 70px;
  height: 600px;
}
.a-input {
}
#bg {
  background: linear-gradient(45deg, #211136, #bf5853);
  height: 100%;
}
.regist {
  color: #333;
  line-height: 40px;
  font-size: 12px;
}
/*绘图*/
#login_img {
  width: 50%;
  height: 100%;
  background: linear-gradient(45deg, #221334, #6c3049);
  float: left;
  position: relative;
}
#login_img span {
  position: absolute;
  display: block;
}
#login_img .circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(45deg, #df5555, #ef907a);
  top: 70px;
  left: 50%;
  margin-left: -100px;
  overflow: hidden;
}
#login_img .circle span {
  width: 150px;
  height: 40px;
  border-radius: 50px;
  position: absolute;
}
#login_img .circle span:nth-child(1) {
  top: 30px;
  left: -38px;
  background: #c55c59;
}
#login_img .circle span:nth-child(2) {
  bottom: 20px;
  right: -35px;
  background: #934555;
}
#login_img .star span {
  background: radial-gradient(#fff 10%, #fff 20%, rgba(72, 34, 64, 0));
  border-radius: 50%;
  box-shadow: 0 0 7px #fff;
}
#login_img .star span:nth-child(1) {
  width: 15px;
  height: 15px;
  top: 50px;
  left: 30px;
}
#login_img .star span:nth-child(2) {
  width: 10px;
  height: 10px;
  left: 360px;
  top: 80px;
}
#login_img .star span:nth-child(3) {
  width: 5px;
  height: 5px;
  top: 400px;
  left: 80px;
}
#login_img .star span:nth-child(4) {
  width: 8px;
  height: 8px;
  top: 240px;
  left: 60px;
}
#login_img .star span:nth-child(5) {
  width: 4px;
  height: 4px;
  top: 20px;
  left: 200px;
}
#login_img .star span:nth-child(6) {
  width: 4px;
  height: 4px;
  top: 460px;
  left: 410px;
}
#login_img .star span:nth-child(7) {
  width: 6px;
  height: 6px;
  top: 250px;
  left: 350px;
}
#login_img .fly_star span {
  width: 90px;
  height: 3px;
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0.67),
    rgba(255, 255, 255, 0)
  );
  background: -o-linear-gradient(
    left,
    rgba(255, 255, 255, 0.67),
    rgba(255, 255, 255, 0)
  );
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.67),
    rgba(255, 255, 255, 0)
  );
  transform: rotate(-45deg);
}
#login_img .fly_star span:nth-child(1) {
  top: 60px;
  left: 80px;
}
#login_img .fly_star span:nth-child(2) {
  top: 210px;
  left: 332px;
  opacity: 0.6;
}
#login_img p {
  text-align: center;
  color: #af4b55;
  font-weight: 600;
  margin-top: 300px;
  font-size: 25px;
}
#login_img p i {
  font-style: normal;
  margin-right: 45px;
}
#login_img p i:nth-last-child(1) {
  margin-right: 0;
}
#login_img p.title2 {
  margin-top: 20px;
}

/* 响应式 */
@media screen and (max-width: 1000px) {
  #login_img {
    display: none;
  }
  #login_wrap {
    width: 490px;
    margin-right: -245px;
  }
  #login {
    width: 100%;
  }
}
@media screen and (max-width: 560px) {
  #login_wrap {
    width: 330px;
    margin-right: -165px;
  }
  #login span {
    margin-left: -125px;
  }
  .form input {
    width: 250px;
  }
  .btn {
    width: 113px;
  }
}
@media screen and (max-width: 345px) {
  #login_wrap {
    width: 290px;
    margin-right: -145px;
  }
}
</style>
